
// const supportedFileTypes = ["pdf", "png", "jpeg", "docx", 'jpg'];

export const getFileType = (url:string) => {
  // Extract file extension from URL
  const lowercaseUrl = url.toLowerCase();
  if (lowercaseUrl.includes('.pdf')) return 'pdf';
  if (lowercaseUrl.includes('.png')) return 'png';
  if (lowercaseUrl.includes('.jpg') || lowercaseUrl.includes('.jpeg')) return 'jpeg';
  // Add more file types as needed
  return ''; // Default empty string
};
